













































import { Vue, Component, Prop } from 'vue-property-decorator';
import { Surface, Typography } from '@/components/atoms';

import CoinsIcon from '@/components/icons/Coins.vue';

@Component({ components: { Surface, Typography, CoinsIcon } })
export default class OfferPreview extends Vue {
  @Prop({ default: '2' }) readonly coins!: string;

  get business() {
    return this.$store.getters['business/getBusinessInfo'].business.name;
  }
}
